<template>
  <div>
    <DialogWrapper
      class="edit-resume-success-dialog"
      :show="true"
      :close-on-click-modal="false"
      :showClose="false"
      :hideFooter="true"
    >
    <div class="content">
      <div class="title-label">{{ $t(`${i18nPrefix}.label.congratulations`) }}</div>
      <div class="title-description">{{ $t(`${i18nPrefix}.label.editResumeSuccess`) }}</div>
      <div class="btn-group">
        <el-button class="button to-personal-home" type="primary" @click="handleToHome">{{ $t(`${i18nPrefix}.btn.homePage`) }}</el-button>
      </div>
    </div>
    </DialogWrapper>
  </div>
</template>

<script>
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
export default {
  components: {
    DialogWrapper
  },
  data () {
    return {
      i18nPrefix: 'personal.resume'
    }
  },
  computed: {
    companyId () {
      return this.$route.query.company_id
    }
  },
  created () {

  },
  methods: {
    handleToHome () {
      this.$router.push({ path: '/recruiting/personal/home', query: { company_id: this.companyId } })
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-resume-success-dialog {

.content {
  padding: 0 25px 0 25px;
  text-align: center;

  .title-label {
    font-weight: 500;
    font-size: 22px;
    color: #303133;
    line-height: 30px;
    margin: 15px 0;
  }

  .title-description {
    font-weight: 400;
    font-size: 16px;
    color: #606266;
    line-height: 22px;
    margin: 5px 0;
    word-break: break-word;
    white-space: pre-wrap;
  }

  .btn-group {
    margin: 20px 0;
    display: flex;
    align-items: center;
    flex-direction: column;

    .button {
      width: 260px;
      height: 40px;
      margin: 5px 0;
    }
  }

}
}
</style>
